import React from 'react';
import PropTypes from 'prop-types';

import MSearchField from '../molecules/fields/_molecules.search-field';

export default class OSearchFilters extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			search: '',
		};

		this.bindHandles();
	}

	bindHandles() {
		this.handleSearch = this.handleSearch.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	handleSearch(search) {
		if (this.props.onClick) {
			this.props.onClick(search);
		}

		this.setState({ search });
	}

	handleChange(search) {
		if (this.props.onChange) {
			this.props.onChange(search);
		}

		this.setState({ search });
	}

	render() {
		return (
			<section className="o-filter-product">
				<MSearchField
					id="IdSearchField"
					label=""
					value={this.state.search}
					onClick={this.handleSearch}
					onChange={this.handleChange}
				/>
			</section>
		);
	}
}

OSearchFilters.propTypes = {
	onClick: PropTypes.func.isRequired,
	onChange: PropTypes.func,
};

OSearchFilters.defaultProps = {
	onChange: undefined,
};



// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.search-filter.js